var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetvision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-2 {\r\n        fill: #5263f7;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "540.01 688.33 568.54 737.76 625.61 737.76 768.33 490.6 739.8 441.1 682.73 441.1 540.01 688.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "397.28 342.24 368.74 391.67 397.27 441.08 682.68 441.1 711.28 391.64 682.75 342.23 397.28 342.24"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "537.75 589.41 482.86 589.41 539.99 688.34 511.46 737.77 454.39 737.77 311.67 490.61 340.21 441.11 397.27 441.11 425.8 490.54 594.88 490.54 537.75 589.41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetvision);
export default __webpack_public_path__ + "static/media/FLEETVISION.64eda867cb45832e3df1d97a2a4680a5.svg";
export { ForwardRef as ReactComponent };